import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import constants from './constants';
import Storage from '~/lib/storage';
var contains = function contains(field, data) {
  return field.toLowerCase().includes(data.toLowerCase());
};
export function load(_ref) {
  var commit = _ref.commit,
    state = _ref.state;
  if (state.items === null || state.items.length <= 0) {
    if (Storage.hasItem(constants.NAMESPACE)) {
      var items = Storage.getItem(constants.NAMESPACE);
      commit('setItems', items);
    }
  }
}
export function loadByRef(_ref2, ref) {
  var commit = _ref2.commit,
    state = _ref2.state;
  var entry = state.items.find(function (item) {
    return item.ref === ref;
  });
  if (entry) {
    // set as product for detail page
    var data = {};
    data[ref] = entry;
    commit('products/updateItems', data, {
      root: true
    });
  }
}
export function add(_ref3, item) {
  var commit = _ref3.commit,
    getters = _ref3.getters;
  if (!getters.getByRef(item.ref)) {
    commit('addItem', item);
  }
}
export function search(_ref4, options) {
  var commit = _ref4.commit,
    state = _ref4.state;
  commit('search/setQuery', options, {
    root: true
  });
  var myItems = [];
  if (state.items !== null && state.items.length > 0) {
    state.items.forEach(function (item) {
      // search for reference number
      if (options.referencenumber && item.ref) {
        if (item.ref === options.referencenumber) {
          myItems.push(item);
        } else {
          // cleanup referencenumber for regex; strip out all: +, -, /
          var cleanedStoredRef = item.ref.replace(/[-+/]/gm, '');
          // some QR Codes reference number have an "0" at the end; strip out last char in case of
          var cleanedGivenRef = options.referencenumber.substring(0, options.referencenumber.length - 1);
          if (cleanedStoredRef === options.referencenumber || cleanedStoredRef === cleanedGivenRef) {
            myItems.push(item);
          }
        }
      } else if (options.fulltext) {
        if (item.ref && contains(item.ref, options.fulltext)) {
          myItems.push(item);
        } else if (item.name && contains(item.name, options.fulltext)) {
          myItems.push(item);
        }
      }
    });
  }
  commit('search/setItems', myItems, {
    root: true
  });
  // set as product for detail page
  var data = {};
  myItems.forEach(function (item) {
    data[item.ref] = item;
  });
  commit('products/updateItems', data, {
    root: true
  });
}